import { render, staticRenderFns } from "./MobileCarousel.vue?vue&type=template&id=a314765c&scoped=true&"
import script from "./MobileCarousel.vue?vue&type=script&lang=js&"
export * from "./MobileCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MobileCarousel.vue?vue&type=style&index=0&id=a314765c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a314765c",
  null
  
)

export default component.exports